<template>
  <div class="max-w-488">
    <h2 v-if="title" class="text-h2 mb-16">{{ title }}</h2>
    <p v-if="description" class="mb-28 md:mb-16">{{ description }}</p>

    <div v-for="section in sections" :key="section.slotName || section.label">
      <div class="mb-28 border-b-1 border-grey-divider-subdued pb-8 border-solid">
        <div class="flex justify-between">
          <h2 class="text-strong-body text-left mb-4">{{ section.label }}</h2>

          <!-- this is not a button because it needs to use the internal router -->
          <router-link v-if="section.editLink" class="text-primary font-semibold uppercase" :to="section.editLink">
            Edit <span class="sr-only">{{ section.ariaLabel || section.label }}</span>
          </router-link>
        </div>

        <template v-if="section.text || section.additionalText">
          <p v-if="section.text" class="text-body text-left mb-16">{{ section.text }}</p>
          <p v-if="section.additionalText" class="text-body text-left mb-16">{{ section.additionalText }}</p>
        </template>
        <slot v-else :name="section.slotName || section.label"></slot>
      </div>
    </div>
    <!-- in case of buttons or footers -->
    <slot></slot>
  </div>
</template>

<script lang="ts">
interface Section {
  label: string;
  slotName?: string;
  editLink?: string;
  ariaLabel?: string;
  text?: string;
  additionalText?: string;
}

export default {
  name: 'SummarySection',
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    sections: {
      type: Array as () => Section[],
      required: true,
    },
  },
};
</script>
